
    <div class="page-padding">
           
        <!--Table View Temperature-->
        <div class="center" *ngIf="TemperatureInspectionList.length==0 ">
            <mat-spinner></mat-spinner>
          </div>
        <div *ngIf="TemperatureInspectionList.length>0 " style="width: max-content; height: 2500px;">
          <tr style="display: flex;">
            <ng-container>
      
              <table style="width: 112px; border-right: outset;">
                <tr class="rowstyle">
                  <span class="cell">{{Translate('Date - Ambient')}}°C </span>
                </tr>
                <tr class="rowstyle">
                  <span class="cell">{{Translate('Inspector')}} </span>
                </tr>
                <tr class="rowstyle">
                  <span class="cell">{{Translate('SMU')}}</span>
                </tr>
                <tr class="rowstyle" style="height: 54px;">
                  <span class="cell"></span>
                </tr>
                <tr class="rowstyle">
                  <span class="cell">{{Translate('Number')}}</span>
                </tr>
      
                <ng-container *ngFor="let inspection of TemperatureInspectionList[0].LeftInspectionDetails">
                  <tr class="rowstyle" style="height: 54px;">
                    <span class="cell">{{inspection.PinNo}}</span>
                  </tr>
                </ng-container>
              </table>
          
            </ng-container>
      
      
      
            <ng-container *ngFor="let inspection of TemperatureInspectionList">
      
              <td>
                <table>
                  <tr class="rowstyle"
                    [class.selectedInspection]="CheckSelectedInspection(inspection.InspectionSummary.InspectionID)">
                    <span class="cell  {{getEval(inspection.InspectionSummary.Eval)}}">
                      <i class="material-icons">
                        fiber_manual_record
                      </i>
                    </span>
                    <span class="cell" style="cursor: pointer;" (click)="GotoFullDetails(inspection.InspectionSummary.InspectionID)">{{inspection.InspectionSummary.InspectionDate |date }} -
                      {{inspection.InspectionSummary.AmbientTem == null? '-':inspection.InspectionSummary.AmbientTem}}°C
                    </span>
                  </tr>
                  <tr class="rowstyle"
                    [class.selectedInspection]="CheckSelectedInspection(inspection.InspectionSummary.InspectionID)">
                    <span class="cell">{{inspection.InspectionSummary.Inspector}}</span>
                  </tr>
                  <tr class="rowstyle"
                    [class.selectedInspection]="CheckSelectedInspection(inspection.InspectionSummary.InspectionID)">
                    <span class="cell">{{inspection.InspectionSummary.SMU}}</span>
                  </tr>
      
                  <tr class="rowstyle">
                    <div class="add-data" style="margin-right: 40px;margin-left: 10px;" [class.has-data]="true">
                        <a target="_blank" href="/api/TemperatureInspection/GetTemperatureInspectionPDF?inspectionId={{inspection.InspectionSummary.InspectionID}}">
                      <i title="Generate Report" class="material-icons">picture_as_pdf</i>
                      </a>
                    </div>
                    <div class="add-data" style="margin-right: 40px;"
                      [class.has-data]="HasComment(inspection.InspectionSummary.InspectionID)">
                      <i title="Add/View Comment" class="material-icons"  (click)="UpdateInspectionComment(inspection.InspectionSummary.InspectionID,inspection.InspectionSummary.Note,false)">comment</i>
                    </div>
                    <div class="add-data" style="margin-right: 40px;">
                       <i  *ngIf="inspection.InspectionSummary.InspectionImage == ''" title="Add/View Image" class="material-icons">camera_alt</i> 
                      <!-- <upload-photo *ngIf="inspection.InspectionSummary.InspectionImage == ''" (onPhotoUpload)="loadTemperatureInspection()" [inspectionId]="inspection.InspectionSummary.InspectionID" [isTempInspection]=true></upload-photo> -->
                      <img (click)="viewInspectionPhoto(inspection.InspectionSummary.InspectionID,inspection.InspectionSummary.InspectionImage,false)" class="inspection-component-photo__photo" [src]="getImage_(inspection.InspectionSummary.InspectionImage)" *ngIf="inspection.InspectionSummary.InspectionImage != ''" />
                      
                    </div>
                    <div class="add-warning" style="margin-right: 10px;"
                      [class.has-value]="HasWarning(inspection.InspectionSummary.InspectionID)">
                      <i title="{{ getWarning(inspection.InspectionSummary.InspectionID) }}"
                        class="material-icons">warning</i>
                    </div>
                  </tr>
                  <tr class="rowstyle">
                    <div style="display: flex; flex-direction: row; justify-content: space-around;">
                      <div style="border-right: solid; width: 50%; height: 33px;">
                        <span class="cell"> {{Translate('Left')}}</span>
                      </div>
                      <div style=" width: 50%;">
                        <span class="cell">{{Translate('Right')}}</span>
                      </div>
                    </div>
                  </tr>
                  <tr class="rowstyle">
                    <div style="display: flex; flex-direction: row; justify-content: space-around;">
                      <div style="border-right: solid; width: 50%;"
                        [class.chainReplace]="inspection.InspectionSummary.IsChainLReplace">
                        <ng-container *ngFor="let LInfo of inspection.LeftInspectionDetails">
                          <div style="display: flex; flex-direction: row; justify-content: space-around; min-height: 54px; max-height: 54px;">
                            <div style="margin-top: 5%; width: 25%; margin-bottom: 5%;" [class.majorOutlier]="IsMajor(LInfo.Outlier)" [class.minorOutlier]="IsMinor(LInfo.Outlier)">
                              <tr >
                                <span class="cell">
                                    <click-to-edit  [major]="IsMajor(LInfo.Outlier)" [minor]="IsMinor(LInfo.Outlier)" [editable]="false" [data]="LInfo.temperature" 
                                    (dataChanged)="updateTemperatureValue($event, LInfo.InspectionDetailId,LInfo.InspectionId)" [alignRight]="true">
                                      </click-to-edit> 
                                </span>
                              </tr>
                            </div>
                            <div style="width: 61%;">
                              <tr>
                                <div class="add-data" id="LInfo.InspectionDetailId" [class.has-data]="HasDetailComment(LInfo.InspectionId,LInfo.InspectionDetailId,1)">
                                  <i title="Add/View Comment" class="material-icons" (click)="UpdateInspectionDetailComment(LInfo.InspectionDetailId,LInfo.Comment,false)">comment</i>
                                </div>
                                <div class="add-data">
                                  <!-- <i title="Add/View Image" class="material-icons">camera_alt</i> -->
                                  <!-- <upload-photo *ngIf="LInfo.Image == ''"  [inspectionDetailId]="LInfo.InspectionDetailId" [isTempInspectionDetail]=true></upload-photo>
                                  <img style="width: 35px;" class="inspection-component-photo__photo" [src]="getImage_(LInfo.Image)" *ngIf="LInfo.Image !=''" /> -->
                                  <i *ngIf="LInfo.Image == ''"  class="material-icons">camera_alt</i> 
                                  <img style="width: 35px;"  (click)="viewInspectionDetailPhoto(LInfo.InspectionDetailId,LInfo.Image,false)"class="inspection-component-photo__photo" [src]="getImage_(LInfo.Image)" *ngIf="LInfo.Image != ''" />
                                  <!-- <upload-photo *ngIf="inspection.InspectionSummary.InspectionImage == ''" (onPhotoUpload)="loadTemperatureInspection()" [inspectionId]="inspection.InspectionSummary.InspectionID" [isTempInspection]=true></upload-photo> -->
                                    
                                </div>
      
                              </tr>
                            </div>
                          </div>
                        </ng-container>
                      </div>
      
                      <div style="width: 50%;" [class.chainReplace]="inspection.InspectionSummary.IsChainRReplace">
                        <ng-container *ngFor="let RInfo of inspection.RightInspectionDetails">
                          <div style="display: flex; flex-direction: row; justify-content: space-around;min-height: 54px; max-height: 54px;">
                            <div style="margin-top: 5%; width: 25%; margin-bottom: 5%;" [class.majorOutlier]="IsMajor(RInfo.Outlier)" [class.minorOutlier]="IsMinor(RInfo.Outlier)">
                              <tr >
                                <span class="cell">
                                    <click-to-edit  [major]="IsMajor(RInfo.Outlier)" [minor]="IsMinor(RInfo.Outlier)" [editable]="false" [data]="RInfo.temperature" 
                                      [alignRight]="true">
                                      </click-to-edit> 
                                </span>
                              </tr>
                            </div>
                            <div style="width: 61%;">
                              <tr>
                                <div class="add-data"id="RInfo.InspectionDetailId" [class.has-data]="HasDetailComment(RInfo.InspectionId,RInfo.InspectionDetailId,2)">
                                  <i title="Add/View Comment" class="material-icons" (click)="UpdateInspectionDetailComment(RInfo.InspectionDetailId,RInfo.Comment,fals)">comment</i>
                                </div>
                                <div class="add-data" >
                                    <i *ngIf="RInfo.Image == ''"  class="material-icons">camera_alt</i> 
                                    <img style="width: 35px;"  (click)="viewInspectionDetailPhoto(RInfo.InspectionDetailId,RInfo.Image,false)"class="inspection-component-photo__photo" [src]="getImage_(RInfo.Image)" *ngIf="RInfo.Image != ''" />
                                    <!-- <upload-photo *ngIf="inspection.InspectionSummary.InspectionImage == ''" (onPhotoUpload)="loadTemperatureInspection()" [inspectionId]="inspection.InspectionSummary.InspectionID" [isTempInspection]=true></upload-photo> -->
                                   
                                </div>
      
                              </tr>
                            </div>
                          </div>
                        </ng-container>
                      </div>
      
      
      </div>
      </tr>
      
      </table>
      </td>
      </ng-container>
      </tr>
      
      </div>
      </div>
      



